<template>
  <div :class="rootClasses" :style="rootStyles">
    <ElementControls
      v-if="editing"
      no-hide
      :no-page-break="!pageBreakAllowed"
      @page-break="$emit('page-break')"
      @delete="$emit('delete')"
      @duplicate="$emit('duplicate')"
    />
    <div
      :style="spacerStyles"
      :class="{ 'spacer-field': true, 'edit-mode-spacer': editing }"
    >
      <div v-if="itemStyling.showDivider" :style="dividerStyle" />
      <template v-else>{{ editing ? "Spacer element" : "" }}</template>
    </div>
  </div>
</template>

<script>
import ElementControls from "@/components/form_fields/shared/element-controls.vue";
import commonStyles from "@/components/form_fields/shared/commonStyles";

export default {
  name: "FormesterSpacer",
  components: {
    ElementControls,
  },
  mixins: [commonStyles],
  props: {
    item: {
      type: Object,
      required: true,
    },
    editing: {
      type: Boolean,
      default: false,
    },
    active: {
      type: Boolean,
      default: false,
    },
    styling: {
      type: Object,
      required: true,
    },
    pageBreakAllowed: {
      type: Boolean,
      default: true,
    },
  },
  emits: ["delete", "page-break", "duplicate"],
  computed: {
    spacerStyles() {
      return {
        height: this.itemStyling.height
          ? `${this.itemStyling.height}px`
          : "10px",
      };
    },
    dividerStyle() {
      return {
        width: "100%",
        height: this.itemStyling.dividerHeight
          ? `${this.itemStyling.dividerHeight}px`
          : "2px",
        backgroundColor:
          this.itemStyling.dividerColor || this.styling.borderColor,
      };
    },
  },
};
</script>

<style>
.spacer-field {
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
}

.edit-mode-spacer {
  opacity: 0.4;
}
</style>
